export const trackEvent = (event, type) => {
  if (window?.umami) {
    window.umami.trackEvent(event, type);
  }
};
